export default __webpack_public_path__ + "static/Vincent-d92bd9183a08c0793cfcded4cc773390.jpg";